import { render, staticRenderFns } from "./statisticChart.vue?vue&type=template&id=47fdd31b&scoped=true&"
import script from "./statisticChart.vue?vue&type=script&lang=js&"
export * from "./statisticChart.vue?vue&type=script&lang=js&"
import style0 from "./statisticChart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./statisticChart.vue?vue&type=style&index=1&id=47fdd31b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fdd31b",
  null
  
)

export default component.exports